'use es6';

import * as API from 'InboxConnectUtils/api/EmailIntegrationApi';
import * as Alerts from 'InboxConnectUtils/utils/Alerts';
const LANG_ROUTE = 'InboxConnectUtils.mailIntegration';
export const enableAccount = (apiClient, emailAddress) => API.enableAccount(apiClient, emailAddress).catch(() => {
  Alerts.addError(`${LANG_ROUTE}.syncError`);
});